import React from 'react'; // eslint-disable-line
import PropTypes from 'prop-types';

import localization from '../../shared/strings';

import FacesDropdown from '../facesDropdown';

const Faces = ({ addFace, selectedFaces, removeFace, changed, fromSearch, withoutLabel, position = "bottom" }) => (
  <div className="itemSearchFilters searchDropdownTop">
    <If condition={!withoutLabel}>
      <div className="labelItemSearchFilters">{localization.SEARCH.text.Faces}</div>
    </If>
    <div className="contentItemSearchFilters">
      <FacesDropdown
        placeholder={localization.DROPDOWN.placeholderFaces}
        placeholderIcon="placeholderFace"
        icon="placeholderFace"
        filterText={localization.DROPDOWN.chooseFaces}
        createText={localization.DROPDOWN.createFace}
        checkedItems={selectedFaces}
        onCheckedHandler={addFace}
        onUncheckedHandler={removeFace}
        canCreate={false}
        changed={changed}
        fromSearch={fromSearch}
        position={position}
      />
    </div>
  </div>
);

Faces.propTypes = {
  selectedFaces: PropTypes.array,
  addFace: PropTypes.func,
  removeFace: PropTypes.func,
  changed: PropTypes.bool,
  fromSearch: PropTypes.bool,
  withoutLabel: PropTypes.bool,
};

export default Faces;
